import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@src/environments/environment';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  data = {
    message: '',
    data: {
      districts_count: 15,
      units_count: 63,
      contractors_count: 30,
      waste_types_count: 4,
      total_weight: 345.196
    }
  };
  constructor(private httpClient: HttpClient) {}

  getData = (url: string, method = 'get') => this.httpClient[method](environment.serverUrl + 'dashboard/' + url);
}
